import { render, staticRenderFns } from "./MaintenanceHistory.vue?vue&type=template&id=23f4ede6"
import script from "./MaintenanceHistory.vue?vue&type=script&lang=js"
export * from "./MaintenanceHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports